// extracted by mini-css-extract-plugin
export default {"pagesContainer":"Pages_pagesContainer__khin9","header":"Pages_header__oIyWI"};